export default "__VITE_ASSET__ClRoh5Gc__"